import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class ReferrerUrlService {
  constructor(private http: HttpClient) {}

  postReferrer(payload, policyNumber): Observable<any> {
    const url = `${environment.backend_server_url_account}/guest/${policyNumber}/referrer-url`;
    return this.http.post(url, payload);
  }
}
